// extracted by mini-css-extract-plugin
export default {"h3":"styles_h3__9MZG6"};